__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "class_mapping_webapp";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common", "11.1.2", function() { return function() { return __webpack_require__(/*! ./node_modules/@angular/common/__ivy_ngcc__/fesm2015/common.js */ 1475); }; }, 1);
			register("@angular/core", "11.1.2", function() { return function() { return __webpack_require__(/*! ./node_modules/@angular/core/__ivy_ngcc__/fesm2015/core.js */ 5003); }; }, 1);
			register("@angular/forms", "11.1.2", function() { return function() { return __webpack_require__(/*! ./node_modules/@angular/forms/__ivy_ngcc__/fesm2015/forms.js */ 3653); }; }, 1);
			register("@angular/router", "11.1.2", function() { return function() { return __webpack_require__(/*! ./node_modules/@angular/router/__ivy_ngcc__/fesm2015/router.js */ 7047); }; }, 1);
			register("@lst/lst-auth", "2.0.6", function() { return function() { return __webpack_require__(/*! ./node_modules/@lst/lst-auth/__ivy_ngcc__/fesm2015/lst-lst-auth.js */ 5094); }; }, 1);
			register("@ng-select/ng-select", "6.1.0", function() { return function() { return __webpack_require__(/*! ./node_modules/@ng-select/ng-select/__ivy_ngcc__/fesm2015/ng-select-ng-select.js */ 1094); }; }, 1);
			register("apollo-angular", "2.4.0", function() { return function() { return __webpack_require__(/*! ./node_modules/apollo-angular/__ivy_ngcc__/fesm2015/ngApollo.js */ 150); }; }, 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};